import React from 'react';
import { ErrorMessage, Field } from 'formik';

export function TextField({name, label, placeholder = '', classes= [], type = 'text'}) {
  classes.push('my-2');
  return (
    <div className={classes.join(' ')}>
      <label className='form-label' htmlFor={name}>{label}</label>
      <Field className='form-control form-control-sm' name={name} placeholder={placeholder} type={type}/>
      <ErrorMessage name={name} component='p' className='field-error mt-2 mb-0'/>
    </div>
  );
}

export function ColorField({name, label, placeholder = '', classes= []}) {
  classes.push('my-2');
  return (
    <div className={classes.join(' ')}>
      <label className='form-label' htmlFor={name}>{label}</label>
      <Field className='form-control form-control-sm' name={name} placeholder={placeholder} type='color'/>
      <ErrorMessage name={name} component='p' className='field-error mt-2 mb-0'/>
    </div>
  );
}

export function TextAreaField({name, label, rows=6, placeholder=''}) {
  return (
    <div className='my-2'>
      <label className='form-label' htmlFor={name}>{label}</label>
      <Field className='form-control form-control-sm' name={name} placeholder={placeholder} as='textarea' rows={rows}/>
      <ErrorMessage name={name} component='p' className='field-error mt-2 mb-0'/>
    </div>
  );
}

export function Checkbox({name, label}) {
  return (
    <div className='my-2 form-checkbox'>
      <label className='form-label' htmlFor={name}>{label}</label>
      <div className='form-control form-control-sm'>
        <Field className='' name={name} type='checkbox'/>
      </div>
      <ErrorMessage name={name} component='p' className='field-error mt-2 mb-0'/>
    </div>
  );
}

export function DropdownField({name, label, options}) {
  return (
    <div className='my-2'>
      <label className='form-label' htmlFor={name}>{label}</label>
      <Field as='select' name={name} className='form-control form-control-sm'>
        {options.map(opt => <option key={opt[1]} value={opt[0]}>{opt[1]}</option>)}
      </Field>
      <ErrorMessage name={name} component='p' className='field-error mt-2 mb-0'/>
    </div>
  );
}
